import { ValidationErrorData } from './common';

export enum TargetPlatformTags {
    APP_METRO = 'app-metro',
    APP_NAVI = 'app-navi'
}

export interface TargetPlatform {
    tag: TargetPlatformTags;
    selected: boolean;
}

export interface TargetTagsEditorState {
    platforms: Record<string, TargetPlatform>;
    errors: ValidationErrorData[];
}
